<template>
    <div>


        <!-- <v-row>
              <v-col cols="6" >
                <v-select
                @change="getAllGradosAdmin(id_nivel)"
                :items="NivelesAdmin"
                v-model="id_nivel"
                item-text="desc_nivel"
                item-value="id_nivel_adm_nivel"
                label="Area"
                single-line
                prepend-icon="fa-layer-group"
              ></v-select>

              </v-col>
              <v-col cols="6" >
              <v-select
              @change="getAllGradosAdmin(id_nivel)"
              :items="NivelesAdmin"
              v-model="id_nivel"
              item-text="desc_nivel"
              item-value="id_nivel_adm_nivel"
              label="Nivel"
              single-line
              prepend-icon="fa-layer-group"
              ></v-select>
              </v-col>
        </v-row> -->

        <v-row v-if="estado">
            <v-col cols="6"  v-for="(area,i) in areacurso" :key="i">
                <!-- cuadro curso padre -->
                <v-card class="dav ma-1">
                    <v-container >
                        <v-row>
                            <v-col :color="area.color" cols="3 text-center" >
                                <v-icon large>{{area.icono_area}}</v-icon>
                            </v-col>

                            <v-col cols="9" :color="area.color" >
                                <h1> {{area.desc_area}} </h1>
                            </v-col>

                            <v-col cols="4"  v-for="(curso,i) in area.cursoGrado" :key="i">
                                <v-item-group>
                                    <v-item v-slot:default="{ active, toggle }">

                                        <!-- cuadro area hijo -->
                                        <v-card
                                        :color="active ? curso.color_curso : ''"
                                        class="d-flex align-center dav"

                                        height="200"
                                        @click="toggle();veropciones(curso)"
                                        >
                                            <v-row >
                                                <v-col cols="12  text-center" :color="curso.color_curso">
                                                    <v-icon large>{{curso.icono_curso}}</v-icon>
                                                </v-col>

                                                <v-col cols="12 text-center">
                                                    {{curso.desc_curso}}<br>
                                                    {{curso.desc_grado}}
                                                </v-col>
                                            </v-row>

                                            <v-scroll-y-transition>
                                                <div v-if="active" ></div>
                                            </v-scroll-y-transition>
                                        </v-card>
                                    </v-item>
                                </v-item-group>
                            </v-col>

                        </v-row>
                    </v-container>


                    <div v-if="opciones">
                        <v-btn small block class="btn_block_style2" dark  @click="consultaEvaluacion()">Gestionar Evaluaciones</v-btn>
                        <v-btn small block class="btn_block_style2 mt-2" dark >Libreta de Notas Bimestral</v-btn>
                        <v-btn small block class="btn_block_style2 mt-2" dark >Libreta de Nota Anual</v-btn>
                    </div> 

                </v-card>
            </v-col>
        </v-row>


        <!-- <pre>{{config}}</pre> -->


        <div v-if="!estado">
            <ConsultaEvaluacion></ConsultaEvaluacion>
        </div>








    </div>
</template>





<script>
    import axios from "../../../helpers/axios";
    import {mapMutations} from 'vuex'
    import ConsultaEvaluacion from './components/consultaEvaluacion.vue'

    export default {
        name: 'gestionevaluacion',

        components:{
            ConsultaEvaluacion
        },

        data: () => ({
            estado: true,
            opciones: false,
            areacurso:[],
            datoLogin: sessionStorage,

            config : {},

        }),

        created(){
            this. setTituloMenu("GESTIÓN DE EVALUACIÓN")
        },


        mounted(){
            this.evadocareacurso()
        },


        methods: {
            ...mapMutations(['setTituloMenu']),
            ...mapMutations('gestEvaluacion', ['setStart']),

            veropciones(item){
                this.opciones = !this.opciones;

                this.config = {cod_docente: 252 , cod_area: item.id_area, cod_curso: item.id_curso, cod_grado: item.id_grado}

            },

            versecciones(){
                this.secciones = !this.secciones;
            },

            async evadocareacurso() {
                let params = { id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                               id_colegio:     this.datoLogin.id_colegio,
                                id_persona:    252,
                }

                try {
                    let response = await axios.post("/evaluacion/docente/areaCurso/",params);
                    this.areacurso = response.data;
                }
                catch (error) {
                    console.log(error);
                }
            },



            // componente de  gestionar evaluciones
            consultaEvaluacion(){
                this.estado = false
                this.setStart(this.config)
            }
        },

    }

</script>





<style scoped>





    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .slide-fade2-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade2-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade2-enter, .slide-fade2-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }



    .dav{

        /* border-radius: 20px;*/
        /* border: 2px solid rgb(105, 85, 218);
        border-top-color: red; */

        border: 2px solid black;
        border-top-color: red;
        box-shadow: 2px 2px;
    }

    .davbox{
        border: 1px solid black;
        border-top-color: red;
    }

    .davbox:hover{
        background-color: rebeccapurple;
    }

</style>